import { roundToTwoDecimal } from '@makemydeal/dr-common-utils';
import type { PaymentTerm, ResidualValueType } from '@makemydeal/dr-platform-types';
import { RESIDUAL_DOLLAR } from '@makemydeal/dr-platform-types';

export const LEASE_RESIDUAL_OVERRIDE_BAGGAGE_NAME = 'mv.leaseResidualOverride';

export type LeaseResidualOverride = { months: number; unit: ResidualValueType; value: number };

export const isPricedWithLeaseResidualOverride = (
    term: PaymentTerm | undefined,
    { unit, value }: LeaseResidualOverride
): boolean => {
    const pricedValue =
        unit === RESIDUAL_DOLLAR
            ? term?.programResidual || term?.baseResidualDollar
            : term?.programResidualPercent || term?.baseResidualPercent;

    return !!pricedValue && roundToTwoDecimal(pricedValue) === roundToTwoDecimal(value);
};
